import { GetterTree } from 'vuex'
import { UserState } from '@/types/User'
import RootState from '@/types/RootState'
import Vote from '@/types/Vote'

export const getters: GetterTree<UserState, RootState> = {
  displayName (state): string {
    return state.user ? state.user.displayName : ''
  },
  userID (state): string {
    return state.user ? state.user.userID : ''
  },
  songsVotedFor (state): Array<Vote> {
    return state.songsVotedFor
  },
  songsVotedForArray (state): Array<string> {
    return Object.values(state.songsVotedFor).map((vote) => vote.requestID)
  }
}
